/**
 * apiFetch — fetch wrapper that automatically injects the CSRF token
 * for state-changing requests (POST/PUT/DELETE/PATCH).
 *
 * The CSRF token is read from the `runner_csrf` cookie, which is issued
 * by the server on login (NOT HttpOnly so JS can read it).
 *
 * Usage:
 *   apiFetch("/api/users/me/races", { method: "POST", body: JSON.stringify(payload) })
 *
 * Spec: specs/phase-1/11-security-baseline.md §1
 */

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

const MUTATING_METHODS = new Set(["POST", "PUT", "DELETE", "PATCH"]);

export async function apiFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const csrfToken = getCookie("runner_csrf");
  const headers = new Headers(init.headers);

  if (csrfToken && init.method && MUTATING_METHODS.has(init.method.toUpperCase())) {
    headers.set("X-CSRF-Token", csrfToken);
  }

  return fetch(url, { ...init, headers, credentials: "include" });
}
